import { useEffect } from 'react';
import { initializeChat } from '@/utils/chatService';

/**
 * ChatWidget Component
 * This component initializes and manages the Tawktrik chat widget.
 * The script is loaded via index.html and initialized here.
 */
const ChatWidget = () => {
  useEffect(() => {
    // Initialize chat when component mounts
    initializeChat();
  }, []);

  return (
    <>
      {/* Tawktrik chat widget will be injected by the external script */}
      <div id="chat-widget-container"></div>
    </>
  );
};

export default ChatWidget;
